import React from "react";
import _ from "lodash";

import { Badge } from "@toddle-edu/ds-web";

import {
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_LEARNING_STANDARD,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_RELATED_CONCEPT,
  ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT,
  ELEMENT_TYPE_DP_SYLLABUS,
} from "Constants/stringConstants";

const suffixComponent = ({ count }) => {
  return (
    <Badge
      type="numeric"
      showZero={true}
      variant="subtle"
      value={count}
      dsVersion="2.0"
    />
  );
};

export const getSideNavigationOptions = ({ rootNodes, parentNodesCount }) => {
  const rootOption = {
    key: "root",
    children: _.map(rootNodes, ({ id }) => id),
  };

  const options = _.map(rootNodes, ({ id, name, label }) => ({
    key: id,
    title: name || label,
    tier: "1",
    parent: "root",
    children: [],
    suffix: suffixComponent({ count: _.get(parentNodesCount, id, 0) }),
  }));

  return [rootOption, ...options];
};

export const getInitialParentNodesCount = ({
  resolvedMinimalTree,
  selectedRows,
  plannerElementType,
}) => {
  const resolvedMinimalTreeIdNodeMap = _.keyBy(
    resolvedMinimalTree.nodes ||
      resolvedMinimalTree.benchmarks ||
      resolvedMinimalTree.atls,
    "id"
  );
  const parentNodesCount = {};
  _.forEach(selectedRows, id => {
    const node = resolvedMinimalTreeIdNodeMap[id];
    switch (plannerElementType) {
      case ELEMENT_TYPE_PYP_LEARNING_STANDARD: {
        // Subject directly present in node
        const subjectId = node.subject;
        parentNodesCount[subjectId] = _.get(parentNodesCount, subjectId, 0) + 1;
        break;
      }
      case ELEMENT_TYPE_MYP_LEARNING_STANDARD:
      case ELEMENT_TYPE_MYP_RELATED_CONCEPT:
      case ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT:
      case ELEMENT_TYPE_DP_LEARNING_STANDARD:
      case ELEMENT_TYPE_DP_SYLLABUS:
      case ELEMENT_TYPE_UBD_LEARNING_STANDARD:
        {
          const subjects = _.get(
            node,
            "dataSetNodeWrapper.properties.subjects",
            []
          );
          _.forEach(subjects, subject => {
            parentNodesCount[subject.id] =
              _.get(parentNodesCount, subject.id, 0) + 1;
          });
        }
        break;
      default: {
        let current = node;
        while (_.get(current, "parent")) {
          const parentNode = resolvedMinimalTreeIdNodeMap[current.parent];
          if (!parentNode) break;
          current = parentNode;
        }
        if (current) {
          parentNodesCount[current.id] =
            _.get(parentNodesCount, current.id, 0) + 1;
        }
      }
    }
  });
  return parentNodesCount;
};
